import React, { memo } from 'react'
import { Box } from 'transfix-ui/core'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { InlineDisplayWrapper } from 'apps/fleet-planner/components/load-details/InlineDisplayWrapper'
import * as Types from 'apps/fleet-planner/types'
import { IInlineDisplayProps } from 'apps/fleet-planner/types'

interface ITruckDisplayProps extends IInlineDisplayProps<Types.ITruck> {
  isExternal?: boolean
  /**
   * @default false
   */
  missingTruckNumber?: boolean
  /**
   * @default false
   */
  missingVin?: boolean
}

export const TruckInlineDisplay = memo<ITruckDisplayProps>(
  ({ isExternal, missingTruckNumber = false, missingVin = false, value: valueProp }) => {
    const { id: idProp, truckNumber: truckNumberProp } = valueProp || {}
    const truckNumber = idProp ? truckNumberProp : undefined
    const { shipmentDetails } = useMarketplaceContext()
    const { info } = shipmentDetails || {}
    const { vin } = info || {}
    const hasHighlight = (missingTruckNumber && !truckNumber) || (missingVin && !vin)

    return (
      <InlineDisplayWrapper
        label='Truck'
        hasHighlight={hasHighlight}
        value={
          <Box display='flex'>
            <Box display='inline-block' pr={1}>
              {truckNumber ?? 'No truck #'}
            </Box>
            {isExternal && (
              <Box>
                <Box pr={1} component='span'>
                  ·
                </Box>
                {vin ?? 'No tractor VIN #'}
              </Box>
            )}
          </Box>
        }
      />
    )
  }
)
